const state = () => ({
    mask: false,
    detailShareDialog: false,
    bvcNFTdetailDialog: false,
    activityIntroDialog: false, // 活动说明弹窗
    depositeDialog: false, // 存币(没有邀请码)弹窗
})

const actions = {
    openDialog({ commit }, dialogName) {
        commit('openDialog', { dialogName })
    },
    closeDialog({ commit }) {
        commit('closeDialog')
    }
}

const mutations = {
    openDialog(state, {dialogName}) {
        state.mask = true;
        state[dialogName] = true;
    },
    closeDialog(state) {
        for(let i in state) {
            state[i] = false; // 关闭所有弹窗，包括mask层
        }
    }
}

export default{
    namespace: true,
    actions: actions,
    mutations: mutations,
    state: state
}